(function () {
  'use strict';

  var PURIFIER_PRODUCT_IDS = [
    15413883208057,
    15413883699577
  ];

  var HYGROMETER_PRODUCT_ID = 15695977808249;
  var CHECK_DELAY = 50;
  var busy = false;
  var pendingTimer = null;

  function getRoot() {
    return window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
      ? Shopify.routes.root
      : '/';
  }

  function getCart() {
    return fetch(getRoot() + 'cart.js?_=' + Date.now(), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart fetch failed: ' + r.status);
      return r.json();
    });
  }

  function getPurifierQty(cart) {
    return cart.items
      .filter(function (item) {
        return PURIFIER_PRODUCT_IDS.indexOf(item.product_id) !== -1;
      })
      .reduce(function (total, item) {
        return total + Number(item.quantity || 0);
      }, 0);
  }

  function getHygrometerLine(cart) {
    return cart.items.find(function (item) {
      return item.product_id === HYGROMETER_PRODUCT_ID;
    }) || null;
  }

  function changeLine(key, quantity) {
    var url =
      window.routes && window.routes.cart_change_url
        ? window.routes.cart_change_url
        : '/cart/change.js';

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart change failed: ' + r.status);
      return r.json();
    });
  }

  function refreshCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return Promise.resolve();

    var currentDrawer = cartDrawer.querySelector('#CartDrawer');
    if (!currentDrawer) return Promise.resolve();

    var url =
      getRoot() +
      '?section_id=cart-drawer&_=' +
      Date.now();

    return fetch(url, {
      headers: { Accept: 'text/html' },
      cache: 'no-store'
    })
      .then(function (r) {
        if (!r.ok) {
          throw new Error('Cart drawer refresh failed: ' + r.status);
        }
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('#CartDrawer');

        if (!newDrawer) {
          newDrawer = doc.querySelector('.cart-drawer');
        }

        if (!newDrawer) return;

        currentDrawer.replaceWith(newDrawer);

        if (newDrawer.querySelector('.drawer__inner-empty')) {
          cartDrawer.classList.add('is-empty');
        } else {
          cartDrawer.classList.remove('is-empty');
        }
      });
  }

  function refreshCartIconBubble() {
    var url =
      getRoot() +
      '?sections=cart-icon-bubble&_=' +
      Date.now();

    return fetch(url, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (sections) {
        if (!sections || !sections['cart-icon-bubble']) return;

        var doc = new DOMParser().parseFromString(
          sections['cart-icon-bubble'],
          'text/html'
        );

        var newBubble = doc.querySelector('#cart-icon-bubble');
        var currentBubble = document.querySelector('#cart-icon-bubble');

        if (newBubble && currentBubble) {
          currentBubble.replaceWith(newBubble);
        }
      })
      .catch(function () {});
  }

  function refreshUI() {
    return Promise.all([
      refreshCartDrawer(),
      refreshCartIconBubble()
    ]);
  }

  function enforce(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      busy = false;
      return Promise.resolve();
    }

    var giftLine = getHygrometerLine(cart);

    if (!giftLine) {
      busy = false;
      return Promise.resolve();
    }

    var purifierQty = getPurifierQty(cart);
    var hygrometerQty = Number(giftLine.quantity || 0);

    if (
      purifierQty > 0 &&
      hygrometerQty <= purifierQty
    ) {
      busy = false;
      return Promise.resolve();
    }

    busy = true;

    var allowedQty = Math.min(
      hygrometerQty,
      purifierQty
    );

    return changeLine(
      giftLine.key,
      allowedQty
    )
      .then(function () {
        return refreshUI();
      })
      .catch(function (error) {
        console.error(
          'gift-hygrometer-limit:',
          error
        );
      })
      .finally(function () {
        busy = false;
      });
  }

  function scheduleCheck() {
    if (busy) return;

    if (pendingTimer) {
      clearTimeout(pendingTimer);
    }

    pendingTimer = setTimeout(function () {
      pendingTimer = null;

      getCart()
        .then(enforce)
        .catch(function (error) {
          console.error(
            'gift-hygrometer-limit:',
            error
          );
        });
    }, CHECK_DELAY);
  }

  function init() {
    if (window.__giftHygrometerLimiterInitialized) {
      return;
    }

    window.__giftHygrometerLimiterInitialized = true;

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        function () {
          scheduleCheck();
        }
      );
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form =
          event.target &&
          event.target.closest
            ? event.target.closest(
                'form[action*="/cart/add"]'
              )
            : null;

        if (!form) return;

        setTimeout(function () {
          scheduleCheck();
        }, 250);
      },
      true
    );

    document.addEventListener(
      'cart:updated',
      function () {
        scheduleCheck();
      }
    );

    scheduleCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();